<template>
    <div id="main" class="select-modal">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("empresa") }}
                            <a
                                class="pl-1"
                                v-if="hide.hideInfo"
                                @click="infoIsHidden()"
                            >
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t($route.meta.contexto)
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: `${abrev}-empresa`,
                                            })
                                        "
                                        >{{ $t("empresas") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? `${$route.params.id} - ${
                                                  loadingName
                                                      ? $t("carregando")
                                                      : name
                                              }`
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: `${abrev}-empresa` })"
                        >
                            {{ $t("voltar") }}
                        </button>
                    </div>
                </div>

                <ul class="nav nav-tabs nav-tabs-main">
                    <router-link
                        tag="li"
                        v-if="permissaoDadosCadastrais.read"
                        :to="{
                            name: `${abrev}-empresa-dados-cadastrais-${
                                isUpdate ? 'edit' : 'new'
                            }`,
                            params: { id: $route.params.id },
                            query: {
                                dadoscadastrais: $route.query.dadoscadastrais 
                                    ? $route.query.dadoscadastrais
                                    : null,
                                politicacomercial: abaSelecionada,
                            }
                        }"
                    >
                        <a>{{ $t("dados-cadastrais") }}</a>
                    </router-link>
                    <router-link
                        tag="li"
                        :to="{
                            name: `${abrev}-empresa-politica-comercial-${
                                isUpdate ? 'edit' : 'new'
                            }`,
                            params: { id: $route.params.id },
                        }"
                    >
                        <a>{{ $t("politica-comercial") }}</a>
                    </router-link>
                </ul>

                <ul class="nav nav-tabs nav-tabs-children">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        :class="{ active: abaSelecionada == i }"
                        v-show="listaPermissoes[aba].read"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <FormaPagamento
                    ref="tabFormaPagamento"
                    v-if="
                        abasAbertas['forma-pagamento'] &&
                        listaPermissoes['forma-pagamento'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'forma-pagamento'"
                />

                <FormaRecebimento
                    ref="tabFormaRecebimento"
                    v-if="
                        abasAbertas['forma-recebimento'] &&
                        listaPermissoes['forma-recebimento'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'forma-recebimento'"
                />

                <PrazoPagamento
                    ref="tabPrazoPagamento"
                    v-if="
                        abasAbertas['prazo-pagamento'] &&
                        !newToEdit &&
                        listaPermissoes['prazo-pagamento'].read
                    "
                    v-show="abas[abaSelecionada] == 'prazo-pagamento'"
                    :isUpdate="isUpdate"
                    @isChanged="isChanged = $event"
                />

                <Blindagem
                    ref="tabBlindagem"
                    v-if="
                        abasAbertas['blindagem'] &&
                        !newToEdit &&
                        listaPermissoes['blindagem'].read
                    "
                    v-show="abas[abaSelecionada] == 'blindagem'"
                    :isUpdate="isUpdate"
                    @isChanged="isChanged = $event"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

// Abas
import PrazoPagamento from "@/components/vendas/empresa/abas/PrazoPagamento";
import FormaPagamento from "@/components/vendas/empresa/abas/FormaPagamento";
import FormaRecebimento from "@/components/vendas/empresa/abas/FormaRecebimento";
import Blindagem from "@/components/vendas/empresa/abas/Blindagem";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";

export default {
    beforeRouteLeave(to, from, next) {
        if (
            from.name == `${this.abrev}-empresa-politica-comercial-new` &&
            to.name == `${this.abrev}-empresa-politica-comercial-edit`
        ) {
            this.isUpdate = true;
            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        PrazoPagamento,
        FormaPagamento,
        FormaRecebimento,
        Blindagem,
    },
    data() {
        return {
            next: undefined,
            abaSelecionada: 0,
            abas: [
                "forma-pagamento",
                "forma-recebimento",
                "prazo-pagamento",
                "blindagem",
            ],
            abasAbertas: {},
            permissao: false,
            permissaoDadosCadastrais: false,
            permissaoPoliticaComercial: false,
            listaPermissoes: {},
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            serviceEmpresa: new EmpresaService(this.$http, this.$router),

            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    mounted() {
        // @85391 - Descontinuado uso da query abaSelecionada em telas que possuem aba e sub-abas
        // if (this.$route.query.abaSelecionada) {
        //     this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        // } else 
        if (this.$route.query.politicacomercial && this.$route.params.id) {
            this.changeTab(this.$route.query.politicacomercial < this.abas.length 
                ? this.$route.query.politicacomercial
                : 0
            );
        }
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "empresa",
                "ven-empresa-dados-cadastrais"
            );
        }else if (this.isAgro){
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess(
                "agro",
                "empresa",
                "agro-empresa-dados-cadastrais"
            );
        }

        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "empresa" },
            });
        } else {
            if (this.isUpdate) this.loadName();

            // Criação dinâmica de listaPermissoes e abasAbertas baseado no nome das tabs
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;

                if (this.isVenda) {
                    this.listaPermissoes[value] = this.hasPermissionAccess(
                        "vendas",
                        "empresa",
                        `ven-empresa-politica-comercial-${value}`
                    );
                }else if (this.isAgro){
                    this.listaPermissoes[value] = this.hasPermissionAccess(
                        "agro",
                        "empresa",
                        `agro-empresa-politica-comercial-${value}`
                    );
                }
            }

            if (this.isVenda) {
                this.permissaoDadosCadastrais = this.hasPermissionAccess(
                    "vendas",
                    "empresa",
                    "ven-empresa-dados-cadastrais"
                );
            }else if (this.isAgro){
                this.permissaoDadosCadastrais = this.hasPermissionAccess(
                    "agro",
                    "empresa",
                    "agro-empresa-dados-cadastrais"
                );
            }

            // Pegar dinâmicamente a primeira aba que estivar com permissão de leitura para a mesma iciciar visível
            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        loadName() {
            this.loadingName = true;
            this.loadNameEmpresa()
                .then((res) => {
                    this.name = res.content.nome;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.loadingName = false;
                })
        },
        loadNameEmpresa() {
            if(this.isVenda) return this.serviceEmpresa.loadNameVendas(this.$route.params.id);
            else if(this.isPromotor) return this.serviceEmpresa.loadNamePromotor(this.$route.params.id);
            else if(this.isDespesa) return this.serviceEmpresa.loadNameDespesas(this.$route.params.id);
            else return this.serviceEmpresa.loadNameAgro(this.$route.params.id);
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            // this.isChanged
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .nav-tabs-main {
            margin-bottom: 10px;
        }
        .nav-tabs-children {
            margin-bottom: 20px;
            li > a {
                text-transform: capitalize;
            }
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }
    }
}
</style>
